import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';

export interface FollowableArrowProps {
  className?: string;
  trigger: HTMLElement | null;
  container: HTMLElement | null;
}

/**
 * An arrow that will follow the trigger element.
 * @arg container is the html element for the parent container where the arrow will be positioned.
 * @arg trigger the html element to follow.
 */
export const FollowableArrow = ({
  className,
  trigger,
  container,
}: FollowableArrowProps) => {
  const [arrowOffset, setArrowOffset] = useState(15);

  // TODO: support multiple arrow directions
  useEffect(() => {
    if (!container || !trigger || typeof window === 'undefined') return;
    const updateArrow = () => {
      const triggerRect = trigger.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      const arrowWidth = 10;
      const offset =
        triggerRect.left -
        containerRect.left -
        arrowWidth +
        triggerRect.width / 2;
      setArrowOffset(offset);
    };

    updateArrow();
    const resizeObserver = new ResizeObserver(updateArrow);
    resizeObserver.observe(trigger);
    resizeObserver.observe(container);

    window.addEventListener('resize', updateArrow);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateArrow);
    };
  }, [container, trigger]);

  return (
    <div
      className={twMerge('absolute', className)}
      style={{ left: arrowOffset, top: '-9px', transform: 'translateX(50%)' }}
    >
      <div
        className="w-0 h-0 border-color-gray-110"
        style={{
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderBottomWidth: '10px',
        }}
      />
    </div>
  );
};
